import React from 'react';
import { useHistory } from 'react-router-dom';
import VenuePaymentConfigForm from 'forms/VenuePaymentConfigForm';
import EditVenueContext from 'contexts/EditVenueContext';
import { getVenue } from 'services/venuesServices';
import Venue from 'types/models/Venue';
import { loadImage } from 'services/imageServices';

export default (): JSX.Element => {
  const history = useHistory();
  const { selectedVenue } = React.useContext(EditVenueContext);
  const [completeVenue, setCompleteVenue] = React.useState<Venue | null>(null);

  const load = React.useCallback(async (id: string) => {
    const venue = await getVenue(id);
    if (!venue) {
      history.push('/private/admin/venues');
      return;
    }

    if (venue.paymentConfig?.fiservQrAspect?.fiservQrScreenLogo) {
      await loadImage(venue.paymentConfig?.fiservQrAspect?.fiservQrScreenLogo);
    }
    setCompleteVenue(venue);
  }, []);

  React.useEffect(() => {
    if (selectedVenue) {
      load(selectedVenue.id);
    } else {
      history.push('/private/admin/venues');
    }
  }, [selectedVenue]);

  if (!completeVenue) return <></>;
  return <VenuePaymentConfigForm venue={completeVenue} />;
};
